export default function PinIcon({ color = '#79778E' }) {

  return (

    <svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3337 6.66683C13.3337 9.61236 8.00033 14.6668 8.00033 14.6668C8.00033 14.6668 2.66699 9.61236 2.66699 6.66683C2.66699 3.72131 5.05481 1.3335 8.00033 1.3335C10.9459 1.3335 13.3337 3.72131 13.3337 6.66683Z" stroke={color} stroke-width="1.5" />
      <path d="M7.99967 7.33333C8.36787 7.33333 8.66634 7.03487 8.66634 6.66667C8.66634 6.29848 8.36787 6 7.99967 6C7.63147 6 7.33301 6.29848 7.33301 6.66667C7.33301 7.03487 7.63147 7.33333 7.99967 7.33333Z" fill={color} stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )

}